import { useQuery } from '@tanstack/react-query';
import { workApi, type StaffApp, type WorkItem } from '@ps/api-client/work';

// Menu badges (docs/06 §4 "count badges"): how much is open in each queue (prototype "Application queue 14"). Counts come
// from the server, worked out from the current state (ADR-072). No polling (ADR-112): they load with the page and after
// this person's own actions; anything else shows on the next page refresh.

export function useWork(app: StaffApp, enabled = true) {
  return useQuery({ queryKey: ['work', app], queryFn: workApi(app).get, enabled });
}

/** Menu badges per path for this app (a detail path such as /customers/:id counts under /customers); `urgent` when any
 *  of it is past its deadline. */
export function workCounts(items: WorkItem[] | undefined, app: StaffApp): Record<string, { count: number; urgent: boolean }> {
  const out: Record<string, { count: number; urgent: boolean }> = {};
  for (const i of items ?? []) {
    if (i.app !== app || !i.count) continue;
    const key = `/${i.path.split('/')[1] ?? ''}`;
    const prev = out[key] ?? { count: 0, urgent: false };
    out[key] = { count: prev.count + i.count, urgent: prev.urgent || !!i.late };
  }
  return out;
}
